import { render, staticRenderFns } from "./IotGatewayPanel.vue?vue&type=template&id=4f5a66c3&lang=pug&"
import script from "./IotGatewayPanel.vue?vue&type=script&lang=ts&"
export * from "./IotGatewayPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports